import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { Assets, Color, FillGradient, Text, TextStyle } from "pixi.js";
import { Tween } from "tweedle.js";
import { LogoComponent } from "../components/logo/LogoComponent";
import { Meter } from "../components/meter/Meter";
import { MeterComponent } from "../components/meter/MeterComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { RIPFeatureComponent } from "../components/rip/RIPFeatureComponent";
import { WinMeterComponent } from "../components/winmeters/WinMeterComponent";
import { isSuperQuickBtnOnGlobal, languageGlobal, RespinIndex, setMaxWinBtnClosedGlobal, waitUntilMaxWinBtnClosed, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { Manager } from "../core/Manager";
import { wait } from "../core/utils";
// import { ParallelTask, Task } from "../core/utils/ParallelTask";
import { sound } from "@pixi/sound";
import { ParallelTask, Task } from "../core/utils/ParallelTask";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { SoundConstants } from "../gameClientEvents/SoundConstants";
import { reelSpinEmitter } from "../reels/ReelInit";
import { RespinObject, spinData } from "../server/getServerResposesFun";
import { BaseGameScene } from "./BaseGameScene";
import { BaseScene } from "./BaseScene";
import { BigWin } from "./BigWin";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

export class FreeGameScene extends BaseScene {
    private fgTransition: Spine | null = null;
    private transitionChangePromise: Promise<void> | null = null;
    private resolveTransitionChange: (() => void) | null = null;
    private numberOfFS: number;
    private baseGameWin: number;
    private totalFGSessionWin: number; // this is total win including base spin

    private firstSpin: boolean = true;

    private numberOfFSPlayed: number = 0;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;
    private retriggerText: Text = new Text({});


    private pointerDownHandlerFree: () => void;

    // private delayBetweenBottomMetersActive: number = 500;

    constructor(numberOfFS: number, baseGameWin: number) {
        super();
        this.numberOfFS = numberOfFS;
        this.numberOfFSPlayed = 0;
        this.baseGameWin = baseGameWin;


        this.totalFGSessionWin = baseGameWin;

        this.firstSpin = true;

        this.pointerDownHandlerFree = this.onBannerPointerDown.bind(this);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);
    }

    private async handleFeature(): Promise<void> {
        return new Promise((resolve) => {
            if (spinData.respins[RespinIndex.value].type === "fs_rip_activated") {
                console.log("rip activated");
                DisplayComponent.get(RIPFeatureComponent).startFeature(() => {
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    public async constructorWithAssets(): Promise<void> {
        this.initBaseLayering('backgroundFree', 'freeBackgroundSkel', 'freeBackgroundAtlas');
        this.setupTransition();

        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();

        this.setupReelFrame("reelBackSkelFree", "reelBackAtlasFree", false);

        this.setupCommonUI();
        (DisplayComponent.get(MeterComponent).getInstance() as Meter).show();
        this.setupRetriggerText();
        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.addChild(this.bigWin);

        this.resize(Manager.screenwidth, Manager.screenHeight);
    }

    private setupRetriggerText() {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
        } = getFontConfig(languageGlobal, "introHeading");

        console.log("setupRetriggerText", fontFamilyHeading, fontWeightHeading);

        this.retriggerText.label = "retriggerText";

        const fill = new FillGradient(0, 0, 0, 25 * 1 * 12);
        const colors = ["#fffbbf", "#fff560", "#fff32f"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.retriggerText.style = new TextStyle({
            fontFamily: "Pop warner",
            fill: "#ffca3b",
            fontWeight: fontWeightHeading,
            fontSize: 140,
            // stroke: {
            //     color: "#ff9c00",
            //     width: 2,
            // },
            // dropShadow:
            // {
            //     blur: 4,
            //     color: "#000000",
            //     distance: 0,
            //     alpha: 1
            // },
            letterSpacing: 2,
            align: "center",

        });

        this.retriggerText.anchor.set(0.5);
        this.retriggerText.position.set(GameConstants.BACKGROUND_SIZE / 2, GameConstants.BACKGROUND_SIZE / 2);

        this.game.addChild(this.retriggerText);

        this.retriggerText.text = "";
        this.retriggerText.scale = 1;
        this.retriggerText.visible = false
    }

    private appearTextRetriggerText(numOfRespins: number): Promise<void> {
        this.retriggerText.text = translationManager.game('banner_retrigger_desc', null, {
            'freegamenumber': `+${numOfRespins}`
        });

        return new Promise<void>((resolve) => {
            this.game.addChild(this.retriggerText);
            this.retriggerText.visible = true;
            const targetScale = Math.min(900 / this.retriggerText.width, 1);

            this.retriggerText.scale.set(0.01);
            sound.play(SoundConstants.FREESPINS_ADDED, {
                volume: 1,
            });

            new Tween(this.retriggerText.scale)
                .to({ x: targetScale, y: targetScale }, 200)
                .start()
                .onComplete(async () => {
                    await (isSuperQuickBtnOnGlobal ? wait(1000) : wait(2000));
                    this.retriggerText.visible = false;
                    this.retriggerText.scale.set(1);
                    resolve();
                });
        });
    }

    public async freeSpinPlay() {
        console.log("casinoChannel-featureRoundStarted")

        // this point to start the transition animation 
        this.fgTransition.state.setAnimation(0, "transition", false);

        console.log("this.numberOfFS", this.numberOfFS);


        console.log("casinoChannel-updateFeatureCounter")

        // this.ui?.resetWinValue();

        const fsRevealIndexes = spinData.respins
            .map((respin, index) => (respin.type === "fs_reveal" ? index : -1))
            .filter(index => index !== -1);

        console.log("fsRevealIndexes", fsRevealIndexes);

        let freeGameTrigger = 1;
        let winAmount: number;
        let accumulatedsWinAmount: number;
        let isFeatureTrigger: boolean;

        while (freeGameTrigger != -1 && freeGameTrigger != -2) {

            Manager.casinoChannelHandler.reportFeatureRoundStarted();


            // let firstSpinMeterPromise: Promise<void> | null = null;

            if (this.firstSpin) // first time counter appear
            {
                this.firstSpin = false;
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((this.baseGameWin * 100).toFixed(0));
                await new Promise(resolve => setTimeout(resolve, 500));

                // Start meter activation based on previous fortuneMeter in parallel with the first spin.
                // firstSpinMeterPromise = this.activateInitialFreegameMeter();

                // await at this point to get transition animation emitt a singnal to start ie, event named "change"
                if (this.transitionChangePromise) {
                    await this.transitionChangePromise;
                    console.log("'change' event awaited and received in freeSpinPlay");
                }

            }

            if (spinData.respins[RespinIndex.value].type === "fs_rip_activated") {
                // await sound.play(SoundConstants.RIP_SYMBOL,{volume: 1});
            } else {
                this.numberOfFS = this.numberOfFS - 1;
                if (this.numberOfFS >= 0) {
                    Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                    this.numberOfFSPlayed = this.numberOfFSPlayed + 1;
                }
            }

            [freeGameTrigger, winAmount, accumulatedsWinAmount, isFeatureTrigger] = await this.spinReel();

            // Ensure the first-spin meter preset has finished once the spin completes.
            // if (firstSpinMeterPromise) {
            //     await firstSpinMeterPromise;
            //     firstSpinMeterPromise = null;
            // }

            console.log("Freegame while loop for", RespinIndex.value, freeGameTrigger, "winAmount", winAmount, "accumulatedsWinAmount", accumulatedsWinAmount, "isFeatureTrigger", isFeatureTrigger);

            if (freeGameTrigger > 0) {

                console.log("RespinIndex.value", RespinIndex.value);
                await this.reels?.processWinFeatureSymbol();

                this.numberOfFS = this.numberOfFS + freeGameTrigger;

                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);

                await this.activateMeterProgress();

                await this.appearTextRetriggerText(freeGameTrigger)


            }

            if (isFeatureTrigger) {
                await this.handleFeature();
                RespinIndex.increase();
            }

            if (winAmount > 0 && freeGameTrigger != -1) {
                await this.bigWin.bigWinFunction(winAmount);
            }

            Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));

            const featureWinCentsNum = Math.floor(winAmount * 100);
            console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

            Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));

            if (winAmount > 0) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }

            if (freeGameTrigger == -1 || freeGameTrigger == -2) {
                this.totalFGSessionWin = accumulatedsWinAmount;
            }

            DisplayComponent.get(RIPFeatureComponent).visibilityCheckForCollectMeter = true;
            if (DisplayComponent.get(RIPFeatureComponent).visibilityCheck) {
                DisplayComponent.get(WinMeterComponent).getInstance().hideCollectMeter();
                DisplayComponent.get(RIPFeatureComponent).visibilityCheck = false;
            }
        }

        console.log("Freegame while loop exit");

        if (Manager.banner) {

            if (freeGameTrigger === -2) { // max win reached
                setMaxWinBtnClosedGlobal(false);
                Manager.casinoChannelHandler.reportMaxWin();

                // wait here till isMaxWinBtnClosedGlobal == true;

                await waitUntilMaxWinBtnClosed();

            }

            Manager.casinoChannelHandler.reportFeatureExit();
            await Manager.banner.appearFreeGameOutroBanner(this.totalFGSessionWin, this.numberOfFSPlayed);

            if (willBannerAutoProceedGlobal) {
                this.callExitFreeGameAuto();
            }

            console.log("appearFreeGameOutroBanner");

            const game = new BaseGameScene();
            await Manager.changeScene(game, false);

            Manager.banner.on('pointerdown', this.pointerDownHandlerFree);

        }


    }

    private async activateMeterProgress() {
        const data: RespinObject = spinData.respins[RespinIndex.value - 1];
        let arr: Task<any>[] = [];
        if (data?.featureData) {
            let prevMeterVal = data.featureData.meterPrevValue;
            let newMeterVal = data.featureData.meterNewValue;
            for (let i: number = (prevMeterVal + 1); i <= newMeterVal; i++) {
                arr.push(() => DisplayComponent.get(MeterComponent).reset(i));
            }
        }
        let pr = new ParallelTask(arr);
        await pr.execute({ stagger: isSuperQuickBtnOnGlobal ? 10 : 100, waitStrategy: "all" });
        return Promise.resolve();
    }

    private callExitFreeGameAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            clearTimeout(this.autoTriggerTimeout);
            console.log("calling freeGameSceneChnage exitFreeGame pointerdown auto")
            this.exitFreeGame();
        }, 10000); // 10 seconds
    }

    private onBannerPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        this.exitFreeGame();

        Manager.banner.off('pointerdown', this.pointerDownHandlerFree);

    }

    private async exitFreeGame() {

        console.log("casinoChannel-featureExit");

        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner();



        // reportGameRoundCompleted();
        Manager.casinoChannelHandler.reportGameRoundCompleted();
        if (DisplayComponent.get(RIPFeatureComponent).visibilityCheck) {
            DisplayComponent.get(WinMeterComponent).getInstance().hideCollectMeter();
            DisplayComponent.get(RIPFeatureComponent).visibilityCheck = false;
        }
        DisplayComponent.get(LogoComponent).resetLogoPositionAfterRIPFeature();
        DisplayComponent.get(RIPFeatureComponent).tintRemovalAfterRoundCompleted();
    }

    private async spinReel(): Promise<[number, number, number, boolean]> {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;
        let isFeatureTrigger = false;

        if (this.reels) {

            [freeGameTrigger, winAmount, accumulatedsWinAmount, isFeatureTrigger] = await this.reels.startPlay("FREEGAME");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

            // this.reels?.setReelRunning(false);
        }

        return [freeGameTrigger, winAmount, accumulatedsWinAmount, isFeatureTrigger];

    }

    private setupTransition(): void {
        this.fgTransition = Spine.from({
            skeleton: "transitionSkel",
            atlas: "transitionAtlas"
        });
        this.fgTransition.label = "fgTransition";

        // Create a Promise that resolves on 'change' event
        this.transitionChangePromise = new Promise<void>((resolve) => {
            this.resolveTransitionChange = resolve;
        });

        this.fgTransition.state.addListener({
            start: () => {
                console.log("fgTransition Started");
            },
            event: (_entry, event) => {
                if (event.data.name === "change") {
                    console.log("fgTransition emitted 'change' event");

                    if (this.resolveTransitionChange) {
                        this.resolveTransitionChange();
                        this.resolveTransitionChange = null; // prevent multiple calls
                    }

                }
            },
            complete: () => {

                this.fgTransition.destroy();
                this.fgTransition = null;
                console.log("fgTransition completed");
            }
        });
    }

    // During the first FREEGAME spin, activate the meter in parallel from deactive
    // based on the previous fortuneMeter value.
    // private async activateInitialFreegameMeter(): Promise<void> {
    //     const currentRespin = spinData.respins[RespinIndex.value];

    //     if (currentRespin?.type !== "fs_reveal") {
    //         return;
    //     }

    //     const prevFortune = spinData?.respins[RespinIndex.value - 2]?.featureData?.fortuneMeter ?? 0;
    //     if (!prevFortune || prevFortune <= 0) {
    //         return;
    //     }

    //     const tasks: Task<any>[] = [];

    //     for (let i = 0; i < prevFortune; i++) {
    //         const id = i + 1;
    //         tasks.push(() => new Promise<void>((resolve) => {
    //             DisplayComponent.get(MeterComponent).activate(id, resolve);
    //         }));
    //     }

    //     // const seq = new ParallelTask(tasks);
    //     await new ParallelTask(tasks).execute({ stagger: this.delayBetweenBottomMetersActive, waitStrategy: "all" });
    // }

    public override destroy() {
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);
        Assets.unload(['freeBackgroundSkel', 'freeBackgroundAtlas']);
        super.destroy();
    }
}
